module.exports = __webpack_public_path__ + "04_medium_black.14c5d936.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_medium_black.png
// module id = SbC3
// module chunks = 0